import { css, Global } from "@emotion/react";
import "react-toastify/dist/ReactToastify.css";
import "cesium/Build/Cesium/Widgets/widgets.css";

const GlobalStyle = () => (
  <Global
    styles={css`
      * {
        font-family: sans-serif;
        letter-spacing: normal;
        line-height: normal;

        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
      body,
      #__next {
        height: 100vh;
        background-color: #ffffff;
      }

      body.Overflow--hidden {
        overflow-y: hidden;
      }

      .cesium-viewer-bottom {
        display: none;
      }
      .cesium-viewer-toolbar {
        display: none;
      }

      /* react-openlayers7 styles */
      .ol-viewport {
        cursor: default;
      }

      .hover-cursor {
        cursor: pointer;
      }

      .ol-full-screen {
        visibility: hidden;
      }

      .react-openlayers-map-container {
        position: relative;
        width: 100%;
        height: 100%;
      }
    `}
  />
);

export default GlobalStyle;
